import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import clientlogo from "../../assets/images/aitt_student_portal_logo.jpg";
import { PostData } from "../../services/PostData";
import * as constants from "../../constants";
import { Cookies } from "react-cookie";
import ErrorSound from "../../assets/sounds/error.mp3";
import { toast } from "react-toastify";
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";

import { AiOutlineLoading3Quarters } from "react-icons/ai"; 
import { sendOtp } from "../../services/helperFunction";

const cookies = new Cookies();

const AITTLoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [passType, setPassType] = useState("password");
  const [errorAudio] = useState(new Audio(ErrorSound));
  const [loading, setLoading] = useState(false);
  const [showpass,setshowpass]=useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = cookies.get("token");
    const studentId = localStorage.getItem("studentId");
    const otpVerified = localStorage.getItem("otpVerified");

    // If user is already logged in
    if (token && studentId) {
      if (otpVerified === "true") {
        // Logged in AND OTP verified → go to dashboard
        navigate("/dashboard", { replace: true });
      } else {
        // Logged in but OTP not verified → go to OTP screen
        navigate("/verifyOtp", { replace: true });
      }
    }
  }, [navigate]);

  const playSound = (audioFile) => {
    audioFile.play();
  };

  const togglepassw=()=>{
    setshowpass(prevState=>!prevState)
  }
  const login = (e) => {
    e.preventDefault();
    if (username && password) {
      setLoading(true);

      PostData("Login", {
        username,
        password,
        CollegeID: constants.COLLEGEID,
      })
        .then((result) => {
          let responseJSON = result;
          if (responseJSON.token) {
            localStorage.setItem("studentId", responseJSON.user.studentId);
            localStorage.setItem("studentName", responseJSON.user.firstName);
            localStorage.setItem("avatarurl", responseJSON.user.imageUrl);
            localStorage.setItem("otpVerified", "false");
            cookies.set("token", responseJSON.token);
            // Send OTP and then navigate
            return sendOtp(String(responseJSON.user.studentId))
              .then(() => {
                navigate("/verifyOtp");
              });
            // navigate("/dashboard");
           
          } else {
            playSound(errorAudio);
            toast.error("Login failed");
           
          }
        })
        .catch((error) => {
          console.log(error, "catch error");
          toast.error("Invalid Credentials",{toastId:"loginerror"})
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") {
      setUsername(value);
    } else if (name === "password") {
      setPassword(value);
    }
  };


  return (
    <>
        <div className="min-h-screen bg-white flex">
          <div className="flex-1 flex flex-col justify-center py-12 px-6 sm:px-6 lg:block lg:px-20 xl:px-24" >
            <div>
              <div>
                {window.configs.showClientLogoLoginPage && <img className="h-18 w-auto" src={clientlogo} alt="Logo" />}
              </div>

              <section className="border shadow-md rounded-lg px-6 py-4 mt-6 mx-auto w-full max-w-sm" >
                <div>
                  <h2 className="text-center text-2xl leading-9 font-extrabold">
                    Student Login
                  </h2>
                </div>
                <div className="mt-8" >
                  <form >
                    <div>
                      <label
                        htmlFor="username"
                        className="block font-semibold text-[#374151] text-[0.875rem]"
                      
                      >
                        User name
                      </label>
                      <div className="mt-[0.25rem] relaive rounded-md shadow-[0 0 0.125rem 0 rgba(0, 0, 0, 0.1)]">
                        <input
                          name="username"
                          id="username"
                          value={username}
                          onChange={onChange}
                          className="
                          w-full font-normal px-3 py-1.5 rounded-lg focus:outline-none text-black border focus:border-blue-800"
                          placeholder="you@example.com"
                        />
                      </div>
                    </div>

                    <div className="mt-[1rem]">
                      <label
                        htmlFor="password"
                        className="block font-semibold text-[#374151] text-[0.875rem]"
                      >
                        Password
                      </label>
                      <div className=" flex mt-[0.25rem] relative rounded-md shadow-[0 0 0.125rem 0 rgba(0, 0, 0, 0.1)]">
                        <input
                          name="password"
                          id="password"
                          value={password}
                          onChange={onChange}
                          type={!showpass?passType:"text"}
                          required
                          className="
                          w-full font-normal px-3 py-1.5 rounded-lg focus:outline-none text-black  border focus:border-blue-800 "
                          placeholder="Password"
                          
                          />
                          <button onClick={togglepassw} className="absolute right-2 top-3" type="button">
                            {
                              showpass?<FaEye/>:<FaEyeSlash></FaEyeSlash>
                            }
                          </button>
                      </div>
                    </div>

                    <div style={{ marginTop: "1.5rem" }}>
                      <span className="block w-full rounded-md shadow-[0 0 0.125rem 0 rgba(0, 0, 0, 0.1)]"
                      >
                        <button type="submit" onClick={login} className="w-full flex gap-x-2 justify-center items-center  text-white bg-[#2662C5] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none">
                          {loading && <AiOutlineLoading3Quarters className="w-4 h-4 fill-white animate-spin"/>}
                          Sign In
                        </button>
                      </span>
                    </div>
                  </form>
                </div>
              </section>
            </div>
          </div>

          <div className="hidden lg:block relative w-0 flex-1 bg-[#2662C5] text-white">
            <section>
              <svg class="inline-block fill-current w-full h-auto text-blue-200/40" viewBox="0 0 1440 450" xmlns="http://www.w3.org/2000/svg">
                <path d="M1189.2 169.2H421H253.8C159.8 169.2 69.1 203.1 0 262.6V449.8C30.5 349.9 131.3 276.7 252 276.7H424.1H1187.4C1280.9 276.7 1371 243.2 1440 184.3V0C1408.1 97.9 1308.3 169.2 1189.2 169.2Z"></path>
              </svg>

              <div className="h-full flex flex-col justify-center px-8 leading-8 mt-10">
                  <h1 className="text-2xl mb-6 font-semibold">Welcome to AITT Student Resource Centre</h1>
                  <p className="text-lg font-medium mb-2">Student Learning Management System </p>

                  <ul className="ml-6">
                    <li className="list-disc">Check Invoices and Payments details online</li>
                    <li className="list-disc">Update your Personal details</li>
                    <li className="list-disc">Check your Enrolments details</li>
                    <li className="list-disc">Check Current and Historical Academic details</li>
                    <li className="list-disc">Student Request Form</li>
                  </ul>
              </div>
            </section>
          </div>
        </div>
     
    </>
  );
};

export default AITTLoginPage;